// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomRadioGroup_container__3d5ZC"};